// @flow

import React from 'react';

import {useAsyncActions} from 'app/utils/redux';
import {createNewProcedure} from 'app/procedures/actions';
import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';

export const NewProcedurePage = () => {
  const actions = useAsyncActions({createNewProcedure});
  return (
    <GenericNewElementPage
      elementName={'procedure'}
      createNewDocument={(procedureData) =>
        actions.createNewProcedure(procedureData)
      }
    />
  );
};
